import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {TooltipModule} from "ngx-tooltip";
import {EnvironmentComponentModule} from "../Environment/EnvironmentComponentModule";
import {ApplicationBarComponent} from "./ApplicationBarComponent";
import {FreshdeskWidgetService} from "./FreshdeskWidgetService";

@NgModule({
    declarations: [ApplicationBarComponent],
    providers: [FreshdeskWidgetService],
    exports: [ApplicationBarComponent],
    imports: [TooltipModule, EnvironmentComponentModule, BrowserModule]
})
export class ApplicationBarModule {
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/ApplicationBar/ApplicationBarModule.ts